module.exports = __webpack_public_path__ + "static/media/switch-on.8dba16bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/switch-on.png
// module id = 249
// module chunks = 0